import { useState, useEffect } from "react";
import "./scss/FreeText.scss";
						
function FreeText({data, value, sending, elementErrors, onChange}) {
	const [err, setErr] = useState(false);
	console.log('~FreeText', data.id, value, elementErrors)
	const setData = (e) => {
		setErr(false);
		const newValue = e.target.value;
		console.log('* FreeText sets and sends:', data.id, value, '->', newValue)
		onChange(data.id, newValue);
	};
	const getStyling = () => {
		let className = "FreeText";
		if(err)	className += ' input--error';
		return className;
	}
	useEffect(() => {
		elementErrors?.errors?.forEach(function(e){
			setErr(true);
		});
	}, [elementErrors])
	return (
		<div className={getStyling()} style={{marginTop:data?.marginTop}}>
			<input
				type="number"
				inputMode="numeric"
				className="NumericPredictionOption__input"
				value={value}
				onChange={setData}
				disabled={sending}
				// placeholder={data.placeholder ? data.placeholder : 'Type here...'}
				style={{
					background: data.background && data.background,
					color: data.textColor && data.textColor,
					margin: "auto",
					width: "200px",
					margin: "auto",
					display: "block",
				}}
			/>
		</div>
	);
};
export default FreeText;
